/**
 * 再認証が必要なことを表すエラー。
 * `@SecureApi` の 401 + code を handleAuthErrorResponse が throw し、
 * handleApiErrorWithReauth が捕捉して再認証→再実行する。
 *
 * - `REAUTH_REQUIRED` → AAL1 鮮度切れ（パスワード再入力 = refresh）
 * - `AAL2_REQUIRED` / `MFA_REAUTH_REQUIRED` → AAL2 / MFA（aal2）
 *
 * `authType` は GlobalAuthModal の AuthType と同形（lib → features 静的依存を避けるため再定義）。
 */
export type ReauthAuthType = 'refresh' | 'aal2';
export class ReauthRequiredError extends Error {
  constructor(readonly displayMessage?: string, readonly authType: ReauthAuthType = 'aal2') {
    super('Reauthentication required');
    this.name = 'ReauthRequiredError';
    Object.setPrototypeOf(this, ReauthRequiredError.prototype);
  }
}